<template lang="pug">
#dashboard-rastreabilidade-subempresa
    BaseHeader#dashboard-rastreabilidade-header(
        :titulo='$t("mensagens.rastreabilidadeEmpresa.dashboard.titulo")',
        icon='mdi mdi-file-download',
        :btnTexto='$t("mensagens.comuns.exportar")',
        :exibeBotao='true',
        @btnHeaderClicado='exportarRelatorioXlsxAR'
    )

    .view-container.margen-bottom-pages
        .bloco-pesquisa-filtros
            BlocoFiltrosDashboard(@emitFiltrosDashboard='filtrar')

        .secao-dashboard
            .titulo-listagem
                h3 {{ $t('mensagens.rastreabilidadeEmpresa.rastreavel') }} / {{ $t('mensagens.rastreabilidadeEmpresa.naoRastreavel') }}

        el-card.bloco-dashboard(:body-style='{ padding: "16px" }')
            .row-dashboard
                span.bloco-dashboard-dados {{ $t('mensagens.rastreabilidadeEmpresa.dashboard.volumeSubtitulo') }}
                    .fields-dashboard
                        .total
                            .totalizador
                                span.valor-totalizador
                                    | {{ formatarTotalizadores(this.dadosDashboard.volumeRastreavel + this.dadosDashboard.volumeNaoRastreavel + this.dadosDashboard.volumeContratosEmAndamento) }}
                                    span(
                                        v-if='this.dadosDashboard.volumeRastreavel + this.dadosDashboard.volumeNaoRastreavel + this.dadosDashboard.volumeContratosEmAndamento !== 0'
                                    ) {{ ' t' }}
                                p {{ $t('mensagens.operacao.dashboard.total') }}
                        .rastreaveis
                            .totalizador
                                span.valor-totalizador
                                    | {{ formatarTotalizadores(this.dadosDashboard.volumeRastreavel) }}
                                    span(
                                        v-if='this.dadosDashboard.volumeRastreavel !== 0'
                                    ) {{ ' t' }}
                                p {{ $t('mensagens.rastreabilidadeEmpresa.rastreaveis') }}
                        .naoRastreaveis
                            .totalizador
                                span.valor-totalizador
                                    | {{ formatarTotalizadores(this.dadosDashboard.volumeNaoRastreavel) }}
                                    span(
                                        v-if='this.dadosDashboard.volumeNaoRastreavel !== 0'
                                    ) {{ ' t' }}
                                p {{ $t('mensagens.rastreabilidadeEmpresa.naoRastreaveis') }}
                        .emAndamento
                            .totalizador.em-andamento
                                span.valor-totalizador
                                    | {{ formatarTotalizadores(this.dadosDashboard.volumeContratosEmAndamento) }}
                                    span(
                                        v-if='this.dadosDashboard.volumeContratosEmAndamento !== 0'
                                    ) {{ ' t' }}
                                p {{ $t('mensagens.rastreabilidadeEmpresa.emAndamento') }}
                span.bloco-grafico
                    GraficoDonut(
                        :configuracoes='this.getConfiguracoes("volume")',
                        :dados='this.dadosVolume',
                        height='150'
                    )

            .row-dashboard
                span.bloco-dashboard-dados {{ $t('mensagens.rastreabilidadeEmpresa.dashboard.contratosSubtitulo') }}
                    .fields-dashboard
                        .total
                            .totalizador
                                span.valor-totalizador
                                    | {{ formatarTotalizadores(this.dadosDashboard.quantidadeContratosRastreavel + this.dadosDashboard.quantidadeContratosNaoRastreavel + this.dadosDashboard.quantidadeContratosEmAndamento) }}
                                    span(
                                        v-if='this.dadosDashboard.quantidadeContratosRastreavel + this.dadosDashboard.quantidadeContratosNaoRastreavel + this.dadosDashboard.quantidadeContratosEmAndamento !== 0'
                                    ) {{ ' (un)' }}
                                p {{ $t('mensagens.operacao.dashboard.total') }}
                        .rastreaveis
                            .totalizador
                                span.valor-totalizador
                                    | {{ formatarTotalizadores(this.dadosDashboard.quantidadeContratosRastreavel) }}
                                    span(
                                        v-if='this.dadosDashboard.quantidadeContratosRastreavel !== 0'
                                    ) {{ ' (un)' }}
                                p {{ $t('mensagens.rastreabilidadeEmpresa.rastreaveis') }}
                        .naoRastreaveis
                            .totalizador
                                span.valor-totalizador
                                    | {{ formatarTotalizadores(this.dadosDashboard.quantidadeContratosNaoRastreavel) }}
                                    span(
                                        v-if='this.dadosDashboard.quantidadeContratosNaoRastreavel !== 0'
                                    ) {{ ' (un)' }}
                                p {{ $t('mensagens.rastreabilidadeEmpresa.naoRastreaveis') }}
                        .emAndamento
                            .totalizador.em-andamento
                                span.valor-totalizador
                                    | {{ formatarTotalizadores(this.dadosDashboard.quantidadeContratosEmAndamento) }}
                                    span(
                                        v-if='this.dadosDashboard.quantidadeContratosEmAndamento !== 0'
                                    ) {{ ' (un)' }}
                                p {{ $t('mensagens.rastreabilidadeEmpresa.emAndamento') }}
                                span.bloco-grafico
                span.bloco-grafico
                    GraficoDonut(
                        :configuracoes='this.getConfiguracoes("contratos")',
                        :dados='this.dadosContratos',
                        height='150'
                    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoFiltrosDashboard from '@/components/contratosOriginacao/dashboard/BlocoFiltrosDashboard.vue';
import RankingVolumeOriginadoPorCriterio from '@/components/contratosOriginacao/dashboard/RankingVolumeOriginadoPorCriterio.vue';
import MapaConcentracaoVolumeContratos from '@/components/contratosOriginacao/dashboard/MapaConcentracaoVolumeContratos.vue';
import DashboardRastreabilidadeServiceEmpresa from '@/services/DashboardRastreabilidadeServiceEmpresa.js';
import GraficoDonut from '@/components/charts/GraficoDonut.vue';
import formatters from '@/utils/formatters';
import { mapGetters } from 'vuex';

export default {
    name: 'DashboardContratosOriginacao',
    components: {
        BaseHeader,
        BlocoFiltrosDashboard,
        GraficoDonut,
        RankingVolumeOriginadoPorCriterio,
        MapaConcentracaoVolumeContratos
    },
    data() {
        return {
            filtro: {
                idCultura: '',
                idSafra: '',
                idEstado: '',
                idFornecedor: '',
                tipoContrato: '',
                idSubTrading: ''
            },
            atualizarDashboard: false,
            dadosDashboard: {
                volumeRastreavel: 0.0,
                volumeNaoRastreavel: 0.0,
                volumeContratosEmAndamento: 0.0,
                quantidadeContratosRastreavel: 0,
                quantidadeContratosNaoRastreavel: 0,
                quantidadeContratosEmAndamento: 0
            },
            dadosVolume: [],
            dadosContratos: []
        };
    },
    computed: {
        ...mapGetters(['isAlvorada'])
    },
    watch: {
        'this.atualizarDashboard': function () {
            if (this.atualizarDashboard) {
                this.atualizarDashboard = false;
                this.updateDados();
            }
        }
    },
    methods: {
        async buscarTotalizadoresDashboard() {
            var filtros = this.filtro || {
                idCultura: '',
                idSafra: '',
                idEstado: '',
                idFornecedor: '',
                tipoContrato: '',
                idSubTrading: ''
            };
            try {
                const { data } =
                    await DashboardRastreabilidadeServiceEmpresa.dashboardSubEmpresa(
                        filtros
                    );
                this.atualizarDashboard = true;
                this.dadosDashboard = data;
                this.dadosContratos = [
                    data.quantidadeContratosRastreavel,
                    data.quantidadeContratosNaoRastreavel,
                    data.quantidadeContratosEmAndamento
                ];
                this.dadosVolume = [
                    data.volumeRastreavel,
                    data.volumeNaoRastreavel,
                    data.volumeContratosEmAndamento
                ];
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.dashboard.erroBuscarDadosRastreabilidade'
                    )
                );
            }
        },
        formatarTotalizadores(valor) {
            return formatters.maxFormatNumber(valor, 2, true);
        },
        async exportarRelatorioXlsxAR() {
            try {
                const dados = {
                    quantidadeContratosTotal:
                        this.dadosDashboard.quantidadeContratosRastreavel +
                        this.dadosDashboard.quantidadeContratosNaoRastreavel +
                        this.dadosDashboard.quantidadeContratosEmAndamento,
                    quantidadeContratosRastreavel:
                        this.dadosDashboard.quantidadeContratosRastreavel,
                    quantidadeContratosNaoRastreavel:
                        this.dadosDashboard.quantidadeContratosNaoRastreavel,
                    quantidadeContratosEmAndamento:
                        this.dadosDashboard.quantidadeContratosEmAndamento,
                    volumeTotal:
                        this.dadosDashboard.volumeRastreavel +
                        this.dadosDashboard.volumeNaoRastreavel +
                        this.dadosDashboard.volumeContratosEmAndamento,
                    volumeRastreavel: this.dadosDashboard.volumeRastreavel,
                    volumeNaoRastreavel:
                        this.dadosDashboard.volumeNaoRastreavel,
                    volumeContratosEmAndamento:
                        this.dadosDashboard.volumeContratosEmAndamento,
                    idCultura: this.filtro.idCultura,
                    idSafra: this.filtro.idSafra,
                    idEstado: this.filtro.idEstado,
                    idFornecedor: this.filtro.idFornecedor
                };
                await DashboardRastreabilidadeServiceEmpresa.exportarRelatorioXlsx(
                    dados
                );
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroExportarRelatorio'
                    )
                );
            }
        },

        updateDados() {
            this.dadosVolume = [
                this.dadosDashboard.volumeRastreavel,
                this.dadosDashboard.volumeNaoRastreavel,
                this.dadosDashboard.volumeContratosEmAndamento
            ];
            this.dadosContratos = [
                this.dadosDashboard.quantidadeContratosRastreavel,
                this.dadosDashboard.quantidadeContratosNaoRastreavel,
                this.dadosDashboard.quantidadeContratosEmAndamento
            ];
        },
        filtrar(filtro) {
            this.filtro.idCultura = filtro.cultura;
            this.filtro.idSafra = filtro.safra;
            this.filtro.idEstado = filtro.estado;
            this.filtro.idFornecedor = filtro.fornecedor;
            this.filtro.idSubTrading = filtro.subTrading || '';
            this.buscarTotalizadoresDashboard();
        },
        getConfiguracoes(tipoGrafico) {
            var configPadrao = {
                title: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    offsetX: 0,
                    offsetY: 5,
                    floating: false,
                    style: {
                        fontSize: '14px',
                        fontWeight: '500',
                        fontFamily: 'Roboto, sans serif',
                        color: '#263238'
                    }
                },
                plotOptions: {
                    pie: {
                        startAngle: -90,
                        endAngle: 90,
                        offsetY: 0,
                        donut: {
                            size: '55%'
                        }
                    }
                },
                grid: {
                    padding: {
                        bottom: -70
                    }
                },
                legend: {
                    position: 'bottom',
                    offsetY: 0,
                    height: 20
                },
                labels: [
                    this.$t('mensagens.rastreabilidadeEmpresa.rastreavel'),
                    this.$t('mensagens.rastreabilidadeEmpresa.naoRastreavel'),
                    this.$t('mensagens.rastreabilidadeEmpresa.emAndamento')
                ],
                colors: ['#6CA352', '#DDAC44', '#0F2C6A'],
                dataLabels: {
                    enabled: false
                },
                tooltip: {
                    theme: 'dark',
                    fillSeriesColor: false,
                    custom: ({ series, seriesIndex, dataPointIndex, w }) => {
                        var soma = series.reduce(function (accumulator, value) {
                            return accumulator + value;
                        }, 0);
                        var porcentagem = (
                            (100 * series[seriesIndex]) /
                            soma
                        ).toFixed(1);
                        return (
                            '<div class="arrow_box">' +
                            '<div class="texto-tooltip">' +
                            w.globals.labels[seriesIndex] +
                            '</div>' +
                            '<div class="valor-tooltip">' +
                            porcentagem +
                            '%</div>' +
                            '</div>'
                        );
                    }
                },
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 600
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }
                ]
            };

            configPadrao.title.text =
                tipoGrafico === 'volume'
                    ? this.$t(
                        'mensagens.rastreabilidadeEmpresa.dashboard.percentualVolume'
                    )
                    : this.$t(
                        'mensagens.rastreabilidadeEmpresa.dashboard.percentualContrato'
                    );
            return configPadrao;
        }
    }
};
</script>

<style lang="scss">
.arrow_box {
    min-width: 120px;

    .texto-tooltip {
        padding: 5px 5px 0 5px !important;
        display: flex;
        justify-content: center;
        font-family: 'Roboto', 'sans serif';
        font-weight: 500;
        font-size: 11px;
    }

    .valor-tooltip {
        padding: 0 5px 5px 5px !important;
        display: flex;
        justify-content: center;
        font-family: 'Roboto', 'sans serif';
        font-size: 13px;
        font-weight: 500;
    }
}

#dashboard-rastreabilidade-subempresa {

    .bloco-pesquisa-filtros,
    .bloco-dashboard {
        margin-top: 20px;

        .row-dashboard {
            display: flex;
        }

        .bloco-dashboard-dados {
            font-weight: 500;
            font-family: 'Roboto', 'sans serif';
            width: 65%;
            margin-top: 20px;
        }

        .bloco-grafico {
            height: auto;
            width: 35%;
        }

        .fields-dashboard {
            margin-top: 5px;
            min-height: 100px;
            width: 100%;
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            grid-template-areas:
                'total rastreaveis naoRastreaveis emAndamento'
                'total rastreaveis naoRastreaveis emAndamento';
            column-gap: 15px;
            color: var(--primary);
            font-family: 'Roboto', 'sans serif';
            font-weight: 500;

            .totalizador {
                border-right: 1px solid rgba(128, 128, 128, 0.486);
                height: 60%;
                margin-right: 30px;

                .valor-totalizador {
                    font-size: 19px;
                    font-weight: 600;
                }
            }

            .totalizador.em-andamento {
                border-right: 0px solid rgba(128, 128, 128, 0.486);
            }

            .total {
                grid-area: total;
            }

            .rastreaveis {
                grid-area: rastreaveis;
            }

            .naoRastreaveis {
                grid-area: naoRastreaveis;
            }

            .emAndamento {
                grid-area: emAndamento;
            }
        }
    }

    .secao-dashboard {
        display: flex;
        margin-top: 20px;
        gap: 25px;
        justify-content: space-between;

        .el-checkbox__label,
        .titulo-listagem h3 {
            font-weight: bold;
        }
    }

    .bloco-rankings {
        display: flex;
        margin-top: 20px;
        gap: 10px;

        .bloco-rankings__por-criterio,
        .bloco-rankings__concentracao-por-estado {
            flex: 1;

            h3 {
                font-weight: bold;
            }
        }
    }
}
</style>
